import React, { ReactNode } from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';

type Props = {
  blockType: string;
  onChange: (event: SelectChangeEvent<string>, child?: ReactNode) => void;
  blockTypeOptions: Array<{ key: string; value: string; label: string }>;
};

export function BlockTypeSelector({ blockType, onChange, blockTypeOptions }: Props) {
  return (
    <FormControl fullWidth>
      <InputLabel id='block-type-select-label'>Moduler</InputLabel>
      <Select
        labelId='block-type-select-label'
        id='block-type-select'
        value={blockType}
        label='Moduler'
        onChange={onChange}>
        <MenuItem value=''>- Velg modul for analyse -</MenuItem>
        {blockTypeOptions.map((opt) => (
          <MenuItem key={opt.key} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
